<!--
  CLIENTES QUE COMPRAN EN EL COMERCIO — pantalla propia, a todo el ancho.
  Superficie plana: `.kb-seccion` y `.kb-tabla-plana`, sin tarjeta alrededor.

  Lo que salió de la pestaña vieja, y por qué:
    · el subtítulo «El cliente es de la organización, no del comercio…» — bajó a
      un renglón al pie, igual que en Organización. Es contexto, no es lo que se
      decide aquí;
    · el aviso de que el buscador mira sólo la página cargada SE QUEDA, y pasa a
      ser la cinta de la pantalla: es honesto y el arreglo es del servidor.
-->
<!-- 🔴 SIN MIGA, SIN TÍTULO Y SIN ENVOLTORIO DE PÁGINA — 2026-09-20.
     Esta pantalla es una RUTA HIJA de la ficha del comercio y se dibuja dentro
     de su `<router-outlet>`. El padre ya pone la miga, el nombre del comercio,
     su estado, la tira del portal y la barra de pestañas: repetirlos acá los
     mostraba DOS VECES, uno debajo del otro, y además `kb-page` anidado dentro
     de `kb-page` duplicaba el relleno y el ancho máximo.
     Lo que sí queda acá son las ACCIONES de esta pantalla. -->
<div class="space-y-8">


  <!-- Esta pantalla no tiene acciones propias: el sublímite se cambia fila por
       fila, dentro de la tabla. Por eso no lleva la barra de botones que sí
       tienen sus hermanas. -->

  <!-- ══ Cargando el comercio ═════════════════════════════════════════════════ -->
  <div *ngIf="cargando" class="space-y-4" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-9 w-full max-w-xl"></div>
    <div class="kb-skeleton h-64 w-full"></div>
  </div>

  <!-- ══ No existe el comercio ════════════════════════════════════════════════ -->
  <div class="kb-empty" *ngIf="!cargando && noEncontrado">
    <span class="kb-empty-icono"><i class="fas fa-store-slash" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No encontramos el comercio «{{ codigo }}»</p>
    <p class="kb-empty-texto">Puede que el código esté mal escrito.</p>
    <a class="kb-btn kb-btn-outline mt-4" [routerLink]="['/console/merchants']">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>Volver a comercios
    </a>
  </div>

  <ng-container *ngIf="!cargando && !noEncontrado">

    <!-- ── LA CINTA: lo que hay que saber al leer esta lista, y va sola ────── -->
    <div class="kb-cinta" *ngIf="busquedaParcial">
      <i class="fas fa-exclamation-triangle kb-cinta-icono" aria-hidden="true"></i>
      <p class="m-0">
        <strong class="font-semibold">La búsqueda es solo sobre esta página.</strong>
        Todavía no busca en el total de afiliados: si no aparece quien buscas,
        puede estar en otra página.
      </p>
    </div>

    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Afiliaciones</h2>
      </div>
      <div class="kb-tarjeta-cuerpo">
      <!-- ── Filtros. Viven en la dirección: el enlace se comparte entero. ─── -->
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex w-full flex-col gap-2 sm:flex-row sm:items-center md:max-w-2xl">
          <div class="kb-buscador w-full">
            <label class="sr-only" for="buscarCliente">Buscar cliente por nombre o cédula</label>
            <i class="fas fa-search kb-buscador-icono" aria-hidden="true"></i>
            <input id="buscarCliente" type="text" class="kb-input kb-input-icono w-full"
                   placeholder="Buscar por nombre o cédula"
                   [(ngModel)]="busqueda" (keyup.enter)="buscar()">
          </div>

          <div class="kb-select-envoltorio shrink-0">
            <label class="sr-only" for="origenCliente">Origen de la afiliación</label>
            <select id="origenCliente" class="kb-select" [(ngModel)]="fuente"
                    (ngModelChange)="buscar()">
              <option value="">Todos los orígenes</option>
              <option value="DERIVED">Derivada de compras</option>
              <option value="PURCHASE">Nació de una compra</option>
              <option value="MANUAL">Cargada a mano</option>
            </select>
            <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
          </div>

          <button type="button" class="kb-btn kb-btn-outline kb-btn-sm shrink-0" (click)="buscar()">
            <i class="fas fa-search" aria-hidden="true"></i>Buscar clientes
          </button>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm shrink-0" *ngIf="busqueda"
                  (click)="limpiarBusqueda()">
            <i class="fas fa-times" aria-hidden="true"></i>Limpiar la búsqueda
          </button>
        </div>

        <p class="shrink-0 text-sm text-muted-foreground">
          <span class="tabular-nums">{{ clientesTotal }}</span>
          {{ clientesTotal === 1 ? 'afiliado' : 'afiliados' }}
        </p>
      </div>

      <!-- ── La tabla, a la vista ──────────────────────────────────────────── -->
      <div class="kb-tabla-plana" *ngIf="clientes.length">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Cliente</th>
              <th class="kb-th">Cédula</th>
              <th class="kb-th">Origen</th>
              <th class="kb-th">Primera compra</th>
              <th class="kb-th">Última compra</th>
              <th class="kb-th kb-th-num">Sublímite</th>
              <th class="kb-th kb-th-acciones">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let af of clientes; trackBy: porId">
              <td class="kb-td kb-td-titulo">
                {{ af.person?.name || '—' }} {{ af.person?.lastname || '' }}
              </td>
              <td class="kb-td kb-td-mono">{{ af.person?.identity_card || '—' }}</td>
              <td class="kb-td">
                <span class="kb-badge kb-badge-contorno">{{ FUENTES[af.source] || af.source }}</span>
              </td>
              <td class="kb-td tabular-nums">
                {{ af.first_purchase_at ? (af.first_purchase_at | date:'dd/MM/yyyy') : '—' }}
              </td>
              <td class="kb-td tabular-nums">
                {{ af.last_purchase_at ? (af.last_purchase_at | date:'dd/MM/yyyy') : '—' }}
              </td>
              <!-- 🔴 El 0 se muestra: un sublímite en 0 significa que no puede
                   comprar aquí, que no es lo mismo que no tener sublímite. -->
              <td class="kb-td kb-td-num">
                <span *ngIf="af.quota_sublimit !== null && af.quota_sublimit !== undefined">
                  {{ af.quota_sublimit | number:'1.2-2' }}
                </span>
                <span class="kb-td-sub" *ngIf="af.quota_sublimit === null || af.quota_sublimit === undefined">
                  usa el cupo global
                </span>
              </td>
              <td class="kb-td-acciones">
                <div class="kb-acciones-grupo" *ngIf="puede('update')">
                  <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm"
                          title="Cambiar el sublímite de este cliente en el comercio"
                          (click)="cambiarSublimite(af)">
                    <i class="fas fa-sliders-h" aria-hidden="true"></i>Cambiar el sublímite
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Paginación: la pide el servidor, no se corta en memoria. -->
        <div class="kb-pager" *ngIf="totalPaginas > 1">
          <p class="kb-barra-nota">
            Página <span class="tabular-nums">{{ pagina }}</span> de
            <span class="tabular-nums">{{ totalPaginas }}</span>
          </p>
          <div class="flex items-center gap-1">
            <button type="button" class="kb-btn kb-btn-outline kb-btn-icon"
                    [disabled]="pagina === 1" (click)="irAPagina(pagina - 1)"
                    aria-label="Página anterior">
              <i class="fas fa-chevron-left" aria-hidden="true"></i>
            </button>
            <button type="button" class="kb-btn kb-btn-outline kb-btn-icon"
                    [disabled]="pagina === totalPaginas" (click)="irAPagina(pagina + 1)"
                    aria-label="Página siguiente">
              <i class="fas fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Vacíos: «no tiene» y «no encontró» no son lo mismo. -->
      <div class="kb-empty" *ngIf="clientesCargados && !clientes.length && (busqueda || fuente)">
        <span class="kb-empty-icono"><i class="fas fa-search" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Ningún cliente coincide con lo buscado</p>
        <p class="kb-empty-texto">
          Recuerda que la búsqueda mira sólo la página cargada: puede estar en otra.
        </p>
        <button type="button" class="kb-btn kb-btn-outline mt-4" (click)="limpiarBusqueda()">
          Limpiar la búsqueda
        </button>
      </div>
      <div class="kb-empty" *ngIf="clientesCargados && !clientes.length && !busqueda && !fuente">
        <span class="kb-empty-icono"><i class="fas fa-users" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Todavía no hay clientes afiliados</p>
        <p class="kb-empty-texto">
          La afiliación se crea con la primera compra, o la deriva el proceso a partir del histórico.
        </p>
      </div>
      <div class="kb-empty" *ngIf="!clientesCargados">
        <span class="kb-empty-icono"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Cargando los clientes…</p>
      </div>
      </div>
    </section>

    <!-- El pie: el contexto que antes era un subtítulo arriba de todo. -->
    <div class="border-t border-border pt-5">
      <p class="m-0 max-w-3xl text-sm text-muted-foreground">
        El cliente es de la organización, no del comercio: su cupo y su historia son de
        CrediTotal. Esta lista sólo dice dónde compra, y el sublímite es un tope para este
        comercio que no toca su cupo global.
      </p>
    </div>

  </ng-container>
</div>
